class RecommendationHelper {
    constructor() {
        this.provider = {
            mailchimp: {
                timestamp: '*|DATE:Y-m-d|*',
                email: '*|EMAIL|*',
            },
            apsis: {
                email: '##SubscriberEmail##',
                timestamp: '##TodayDate##',
            },
            crall: {
                email: '@@EMAIL@@',
                timestamp: '@@TODAY@@',
            },
            custom: {
                email: '[INSERT_EMAIL_ADDRESS]',
                timestamp: '[INSERT_DATE]',
            },
        }
    }

    getProvider(provider) {
        return this.provider[provider];
    }

    emailCode(recommendation, provider) {
        let code = `<center>`;
        for (let i = 0; i < recommendation.number_of_products; i++) {
            code += `
    <a href="https://app.crall.io/beacon/v1/recommendation/${recommendation.id}/embed/click?i=${i}&email=${this.getProvider(provider).email}" style="text-decoration: none;" target="_blank">
        <img style="max-width:165px;width:23%;" width="23%" src="https://app.crall.io/beacon/v2/recommendation/${recommendation.account_id}/${recommendation.description}/embed?i=${i}&timestamp=${this.getProvider(provider).timestamp}&email=${this.getProvider(provider).email}" />
    </a>`;
        }
        code += `
</center>`;

        return code;
    }

}


export default new RecommendationHelper();



// WEBPACK FOOTER //
// ./containers/recommendations/RecommendationHelper.js